/**
 * チャットパネルのヘッダーコンポーネント
 *
 * タイトル、セッション情報、アクションボタンを表示
 */

import { Group, Stack, Title, Text, ActionIcon, Tooltip } from "@mantine/core";
import { ChevronRight, Sparkles, History } from "lucide-react";

interface ChatPanelHeaderProps {
  currentSessionId: string | null;
  onClose: () => void;
  onOpenHistory: () => void;
}

/**
 * チャットパネルヘッダー
 */
export function ChatPanelHeader({
  currentSessionId,
  onClose,
  onOpenHistory,
}: ChatPanelHeaderProps) {
  return (
    <Group
      p="md"
      justify="space-between"
      style={{
        borderBottom: "1px solid var(--mantine-color-default-border)",
      }}
    >
      <Group gap="sm">
        <ActionIcon variant="subtle" onClick={onClose}>
          <ChevronRight size={20} />
        </ActionIcon>
        <Sparkles
          size={28}
          strokeWidth={1.5}
          color="var(--mantine-color-blue-6)"
        />
        <Stack gap={0}>
          <Title order={5}>AIアシスタント</Title>
          {currentSessionId && (
            <Text size="xs" c="dimmed">
              セッション中
            </Text>
          )}
        </Stack>
      </Group>

      <Group gap="xs">
        <Tooltip label="会話履歴">
          <ActionIcon variant="subtle" onClick={onOpenHistory}>
            <History size={18} />
          </ActionIcon>
        </Tooltip>
      </Group>
    </Group>
  );
}
